var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0 flex items-center justify-center"},[_c('spinner',{class:`${_vm.$is_cncc ? 'text-white' : ''}`,attrs:{"sizes":"w-20 h-20","thickness":"border-8"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }